import type { PrefStore } from "./point-markers.ts";

const SNAP_KEY = "mapus.snap";

/** Snap starts on. Only an explicit "0" from the toolbar or the S key keeps it off. */
export function readSnapPref(store: PrefStore): boolean {
  try {
    return store.getItem(SNAP_KEY) !== "0";
  } catch {
    return true;
  }
}

export function writeSnapPref(store: PrefStore, on: boolean): void {
  try {
    store.setItem(SNAP_KEY, on ? "1" : "0");
  } catch {
    /* private mode or a full disk — the choice still applies this session */
  }
}
